<template>
    <div class="billing-period-container">
        <div class="billing-period-button" v-for="(period, key) in periods" :key="key"
            :class="{ active: key === value }" @click="$emit('input', key)">
            {{ period }} <span v-if="discount[key] > 0">{{ discount[key] }}%</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "PlanPeriods",
    props: {
        value: {
            type: String,
            default: "monthly",
        },
    },
    data() {
        return {
            periods: {
                monthly: this.$t("billing.monthly"),
                "monthly-3": this.$t("billing.threeMonthly"),
                "monthly-6": this.$t("billing.sixMonthly"),
                annual: this.$t("billing.yearly"),
                "annual-2": this.$t("billing.twoYearDiscount"),
            },
            discount: {
                monthly: 0,
                "monthly-3": 5,
                "monthly-6": 10,
                annual: 20,
                "annual-2": 30,
            },
        };
    },
};
</script>
<style lang="scss" scoped>
.billing-period-container {
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 6px;
    background-color: #f7f9fc;
    gap: 8px;

    .billing-period-button {
        padding: 8px 16px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        display: flex;
        align-items: center;
        height: 40px;
        gap: 6px;
        color: #333;
        font-weight: 600;
        background-color: #ffffff;
        border: 1px solid #ddd;
        transition: all 0.2s ease-in-out;

        span {
            color: #ffffff;
            font-size: 12px;
            background: #f79d65;
            border-radius: 4px;
            padding: 2px 6px;
            font-weight: bold;
        }

        &:hover {
            background: #fd8544;
            color: #ffffff;
            border-color: #f79d65;
            box-shadow: 0 2px 6px rgba(138, 53, 0, 0.15);
        }

        &.active {
            background: #f79d65;
            color: #ffffff;
            border-color: #f79d65;

            span {
                background: #ffe6d5;
                color: #f07935;
            }
        }
    }
}
</style>
